import { helper } from '@ember/component/helper';

export function randomNumber(params, { max }) {
  return Math.floor(Math.random() * Math.floor(max));
}

export default helper(randomNumber);
